export default "__VITE_ASSET__oS4HESMu__"